import React, { useEffect, useState, createElement, Component } from 'react';
import { motion, AnimatePresence, useScroll, useMotionValueEvent } from 'framer-motion';
import { Star, Heart, MessageCircle, CheckCircle2, CreditCard, Users, Ticket, ChevronRight, X, Shield, Calendar, Infinity as InfinityIcon, Handshake, ChevronDown, HelpCircle, Camera } from 'lucide-react';
// --- Constants & Data ---
const CHECKOUT_LINK = 'https://primex-digital.shop/cart/45146186350701:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/d9vwAN1NbK8GegnodW1f3J/Gemini_Generated_Image_ad7ae2ad7ae2ad7a_(1).webp';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/hyRjcsCfC9oubUGBy62xij/sacame_el_titulo_202604231454.jpg';
const PROJECTS = [{
  url: 'https://cdn.magicpatterns.com/uploads/9Qa3iMD9qD7QJdKHDv7pSL/eb665db206088b9577459c20e9c565f1.jpg',
  title: 'Top Rayado Azul',
  comment: '¡Un diseño fresco y moderno que todas quieren tener!'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/aQwuvqMdppPvopx5rooSeV/Gemini_Generated_Image_gn180ign180ign18.png',
  title: 'Manta de Grannys',
  comment: 'Un clásico que nunca falla, llena de color y calidez.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ksU5Uo7dQMpiGrGZcccnaz/Prompt_idea___Hiperrealista_202604241423_(1).jpg',
  title: 'Almohadón Decorativo',
  comment: 'Texturas que enamoran y transforman cualquier espacio.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3pK23SqLvuAhaaVbd4fqQr/Prompt_idea___Hiperrealista_202604241423.jpg',
  title: 'Bolso Playero Multicolor',
  comment: 'Resistente, alegre y con un acabado profesional increíble.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/pFgXee8bRZbkdaMAsPtN8G/_Hiperrealista_primer_plano_202604241413.jpg',
  title: 'Set de Bebé Natural',
  comment: 'Pura ternura en cada punto, el regalo más especial.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/uH3dmvb5P6WdGkd9z8zA5U/e281a48123fedb0da68a28313ae11b4d.jpg',
  title: 'Llavero Conejito',
  comment: 'Un detalle adorable y rápido de tejer para regalar.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/71NrGNGwRTowLrqdN1dyBx/Gemini_Generated_Image_do8gq5do8gq5do8g_(1).png',
  title: 'Bolso Matero Verde',
  comment: 'Elegancia y funcionalidad en un diseño de punto fantasía.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/9z426dRo3ZX8qnCZcw7LeR/_Hiperrealista_primer_plano_202604241402.jpg',
  title: 'Top de Grannys Lavanda',
  comment: 'La tendencia boho-chic llevada a su máxima expresión.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ggBZ6EgGjVihSEnfBUa6B5/quiero_que_el_202604241355.jpg',
  title: 'Tote Bag Minimalista',
  comment: 'Simple, sofisticado y perfecto para el uso diario.'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/8UabECVL5irwKebE7HAPH4/quiero_que_me_202604241250.jpg',
  title: 'Ramo de Flores Eternas',
  comment: 'Un jardín que nunca marchita, tejido con puro amor.'
}];
const BONUSES = [{
  id: 1,
  title: 'BONO #1 - LA ESENCIA DEL TEJIDO',
  desc: 'Los secretos técnicos para que tus acabados sean perfectos y profesionales, eliminando esos pequeños errores que delatan a una principiante.',
  img: 'https://cdn.magicpatterns.com/uploads/hetHGg8n8S3h3i214rpLof/bono1.webp'
}, {
  id: 2,
  title: 'BONO #2 - DULCE COMPAÑÍA',
  desc: 'La colección especializada en amigurumis y muñecos. El regalo perfecto para tus nietos o el producto más vendido si decidís emprender.',
  img: 'https://cdn.magicpatterns.com/uploads/sHfVLJvHFBNv9aF73zBtjZ/bono2.webp'
}, {
  id: 3,
  title: 'BONO #3 - FLORECER EN HILOS',
  desc: 'Guía paso a paso para crear flores tridimensionales que transformarán cualquier prenda básica en una pieza de diseño única.',
  img: 'https://cdn.magicpatterns.com/uploads/f9NZXMXbHdh7hBDSv7aULR/bono3.webp'
}, {
  id: 4,
  title: 'BONO #4 - TRAMAS QUE ACOMPAÑAN',
  desc: 'Diseños de mantas y bolsos de gran formato, ideales para decorar tu hogar o hacer los regalos más inolvidables de tu círculo social.',
  img: 'https://cdn.magicpatterns.com/uploads/j1VTZQYK1FdX2aRr2wJkmw/agregame_por_ahi_202604231713.webp'
}, {
  id: 5,
  title: 'BONO #5 - MODA CON ALMA',
  desc: 'Aprendé a tejer ropa que realmente quede bien. Blusas, cardigans y accesorios con estilo contemporáneo y elegante.',
  img: 'https://cdn.magicpatterns.com/uploads/hG2p27rgETTkkhYhiZdwtW/bono5.webp'
}];
const TESTIMONIALS = [{
  name: 'Marta G.',
  text: 'che no puedo creer lo q estoy viendo, los patrones son re claros. antes me volvia loca con los de youtube q no se entendia nada. mil gracias!',
  rating: 5
}, {
  name: 'Silvia de Cordoba',
  text: 'lo compre ayer y ya termine un amigurumi para mi nieta. quedo divino mal. valio cada peso.',
  rating: 5
}, {
  name: 'Graciela',
  text: 'al principio dudaba x el precio pero la verdad q la calidad es otra cosa. se nota q saben lo q hacen.',
  rating: 4
}, {
  name: 'Mirta R.',
  text: 'estaba cansada de desarmar todo el tiempo. con hilos que enamoran por fin me sale todo de una. re contenta!',
  rating: 5
}, {
  name: 'Elena',
  text: 'muy bueno todo, los bonos son geniales. el de las flores me encanto.',
  rating: 5
}];
const ARG_CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
const NAMES = ['Maria', 'Ana', 'Juana', 'Beatriz', 'Graciela', 'Marta', 'Silvia', 'Elena', 'Patricia', 'Rosa'];
// --- Countdown Timer Component ---
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState<{
    hours: number;
    minutes: number;
    seconds: number;
  } | null>(null);
  useEffect(() => {
    const STORAGE_KEY = 'hilos_enamoran_timer_end';
    const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
    let endTime = localStorage.getItem(STORAGE_KEY);
    const now = new Date().getTime();
    if (!endTime || now > parseInt(endTime)) {
      const newEndTime = now + TWENTY_FOUR_HOURS;
      localStorage.setItem(STORAGE_KEY, newEndTime.toString());
      endTime = newEndTime.toString();
    }
    const timer = setInterval(() => {
      const currentTime = new Date().getTime();
      const difference = parseInt(endTime!) - currentTime;
      if (difference <= 0) {
        const newEndTime = currentTime + TWENTY_FOUR_HOURS;
        localStorage.setItem(STORAGE_KEY, newEndTime.toString());
        endTime = newEndTime.toString();
      } else {
        const hours = Math.floor(difference / (1000 * 60 * 60) % 24);
        const minutes = Math.floor(difference / 1000 / 60 % 60);
        const seconds = Math.floor(difference / 1000 % 60);
        setTimeLeft({
          hours,
          minutes,
          seconds
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!timeLeft) return null;
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex items-center gap-1" data-id="element-0">
      <div className="bg-white/20 backdrop-blur-sm px-2 py-0.5 rounded-lg border border-white/30 min-w-[32px] flex items-center justify-center" data-id="element-1">
        <span className="text-sm font-black tabular-nums" data-id="element-2">
          {value.toString().padStart(2, '0')}
        </span>
      </div>
      <span className="text-[7px] uppercase font-bold opacity-70" data-id="element-3">{label}</span>
    </div>;
  return <div className="flex items-center mr-[60px] gap-[0px]" data-id="element-4">
      <TimeUnit value={timeLeft.hours} label="h" data-id="element-5" />
      <span className="text-sm font-bold opacity-50" data-id="element-6">:</span>
      <TimeUnit value={timeLeft.minutes} label="m" data-id="element-7" />
      <span className="text-sm font-bold opacity-50" data-id="element-8">:</span>
      <TimeUnit value={timeLeft.seconds} label="s" data-id="element-9" />
    </div>;
};
// --- Custom Icons ---
const YarnBallIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-10">
    <circle cx="12" cy="12" r="10" data-id="element-11" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10" data-id="element-12" />
    <path d="M12 2a15.3 15.3 0 0 0-4 10 15.3 15.3 0 0 0 4 10" data-id="element-13" />
    <path d="M2 12h20" data-id="element-14" />
    <path d="M12 2v20" data-id="element-15" />
    <path d="M7 7l10 10" data-id="element-16" />
    <path d="M7 17L17 7" data-id="element-17" />
  </svg>;
// --- Components ---
const PurchasePopup = () => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const show = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: ARG_CITIES[Math.floor(Math.random() * ARG_CITIES.length)]
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    // Changed interval to 45 seconds to be less annoying
    const interval = setInterval(show, 45000);
    setTimeout(show, 8000); // Initial delay
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-18">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0,
      scale: 0.8
    }} animate={{
      x: 20,
      opacity: 1,
      scale: 1
    }} exit={{
      x: -100,
      opacity: 0,
      scale: 0.8
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-10 left-0 z-50 bg-white/95 backdrop-blur-md p-1 rounded-3xl shadow-[0_20px_50px_rgba(47,82,51,0.15)] flex items-center gap-4 border border-[#2F5233]/20 max-w-[320px] overflow-hidden" data-id="element-19">
          <div className="relative" data-id="element-20">
            <div className="bg-gradient-to-br from-[#E07A5F] to-[#D1694E] p-3 rounded-2xl shadow-inner" data-id="element-21">
              <YarnBallIcon className="text-white w-6 h-6 animate-spin-slow" data-id="element-22" />
            </div>
            <div className="absolute -top-1 -right-1 bg-[#2F5233] rounded-full p-1 border-2 border-white" data-id="element-23">
              <CheckCircle2 className="text-white w-2 h-2" data-id="element-24" />
            </div>
          </div>
          <div className="pr-4 py-2" data-id="element-25">
            <p className="text-sm font-bold text-[#2F5233] leading-tight" data-id="element-26">
              ¡{data.name} de {data.city}!
            </p>
            <p className="text-[11px] text-[#8D7B6D] font-medium" data-id="element-27">
              Acaba de unirse a la comunidad 🧶
            </p>
            <div className="mt-1 flex items-center gap-1" data-id="element-28">
              <div className="flex gap-0.5" data-id="element-29">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-2 h-2 fill-[#E07A5F] text-[#E07A5F]" data-id="element-30" />)}
              </div>
              <span className="text-[9px] text-[#E07A5F] font-bold uppercase tracking-tighter" data-id="element-31">
                Compra Verificada
              </span>
            </div>
          </div>
          <div className="absolute right-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#E07A5F] via-[#2F5233] to-[#E07A5F]" data-id="element-32" />
        </motion.div>}
    </AnimatePresence>;
};
const StickyHeader = ({
  onAction
}: {
  onAction: () => void;
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    if (latest > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  });
  return <AnimatePresence data-id="element-33">
      {isVisible && <motion.div initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} className="fixed top-0 left-0 right-0 z-[100] bg-white/80 backdrop-blur-md border-b border-[#2F5233]/10 py-3 px-6 shadow-lg flex items-center justify-between" data-id="element-34">
          <div className="flex items-center gap-2" data-id="element-35">
            <div className="w-8 h-8 bg-[#2F5233] rounded-full flex items-center justify-center" data-id="element-36">
              <Heart className="w-4 h-4 text-white fill-white" data-id="element-37" />
            </div>
            <span className="font-bold text-[#2F5233] hidden sm:block" data-id="element-38">
              Hilos que Enamoran
            </span>
          </div>

          <div className="absolute left-1/2 -translate-x-1/2" data-id="element-39">
            <CountdownTimer data-id="element-40" />
          </div>

          <div className="flex items-center gap-4" data-id="element-41">
            <button onClick={onAction} className="bg-[#E07A5F] text-white px-6 py-2.5 rounded-full font-black uppercase shadow-md hover:bg-[#D1694E] transition-all active:scale-95 mr-[-20px] text-[12px]" data-id="element-42">
              VER OFERTA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
const ScrollReveal = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 40
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 1.2,
  delay,
  ease: [0.21, 0.47, 0.32, 0.98]
}} data-id="element-43">
    {children}
  </motion.div>;
const CommentSection = () => {
  const AVATAR_COLORS = ['from-[#2F5233] to-[#4A7856]', 'from-[#E07A5F] to-[#D1694E]', 'from-[#9FD9D3] to-[#6BC4B8]', 'from-[#8D7B6D] to-[#A69484]', 'from-[#D4AF37] to-[#C49B2A]', 'from-[#B56576] to-[#9E4F5E]', 'from-[#6D597A] to-[#5B4868]', 'from-[#355070] to-[#2A4059]'];
  const AVATAR_EMOJIS = ['🧶', '🪡', '🧵', '🌸', '🌿', '💐', '🎀', '🦋', '🌻', '🐰', '🧸', '✨', '💜', '🌺', '🍀', '🎨', '🪻', '🐱', '🌷', '🫧'];
  const [comments, setComments] = useState([{
    id: 1,
    user: 'Norma Beatriz',
    avatar: 'NB',
    emoji: '🧶',
    colorIdx: 0,
    date: 'hace 2 horas',
    rating: 5,
    text: 'Increíble la calidad de los gráficos. Por fin entiendo cómo cerrar bien los puntos. ¡Muy recomendado!',
    likes: 24,
    isLiked: false
  }, {
    id: 2,
    user: 'Graciela M.',
    avatar: 'GM',
    emoji: '🪡',
    colorIdx: 1,
    date: 'hace 4 horas',
    rating: 5,
    text: 'Los amigurumis son un sueño. Ya terminé mi primer muñeco para mi nieta y quedó precioso.',
    likes: 18,
    isLiked: false
  }, {
    id: 3,
    user: 'Marta Silvia',
    avatar: 'MS',
    emoji: '🌸',
    colorIdx: 2,
    date: 'hace 5 horas',
    rating: 4,
    text: 'Muy completo todo. Me gustaría que suban más de ropa de invierno, pero el set de bebé es precioso.',
    likes: 12,
    isLiked: false
  }, {
    id: 4,
    user: 'Elena R.',
    avatar: 'ER',
    emoji: '🧵',
    colorIdx: 3,
    date: 'hace 1 día',
    rating: 5,
    text: 'Los patrones son muy claros, valió la pena la inversión. Ya estoy empezando el tercer proyecto.',
    likes: 9,
    isLiked: false
  }, {
    id: 5,
    user: 'Patricia G.',
    avatar: 'PG',
    emoji: '🌿',
    colorIdx: 4,
    date: 'hace 1 día',
    rating: 5,
    text: 'Excelente atención y los archivos llegan al toque. Los diseños son muy originales.',
    likes: 15,
    isLiked: false
  }, {
    id: 6,
    user: 'Rosa Inés',
    avatar: 'RI',
    emoji: '💐',
    colorIdx: 5,
    date: 'hace 2 días',
    rating: 4,
    text: 'Me encantaron los bonos, especialmente el de las flores. Muy bien explicado todo.',
    likes: 7,
    isLiked: false
  }, {
    id: 7,
    user: 'Mirta Beatriz',
    avatar: 'MB',
    emoji: '🎀',
    colorIdx: 6,
    date: 'hace 2 días',
    rating: 5,
    text: 'Por fin encontré patrones que se entienden de verdad. ¡Gracias por compartir su talento!',
    likes: 21,
    isLiked: false
  }, {
    id: 8,
    user: 'Alicia S.',
    avatar: 'AS',
    emoji: '🦋',
    colorIdx: 7,
    date: 'hace 3 días',
    rating: 5,
    text: 'El grupo de apoyo es genial. Siempre hay alguien para sacarte las dudas.',
    likes: 11,
    isLiked: false
  }, {
    id: 9,
    user: 'Susana T.',
    avatar: 'ST',
    emoji: '🌻',
    colorIdx: 0,
    date: 'hace 3 días',
    rating: 5,
    text: 'La biblioteca es inmensa, hay para todos los gustos. Muy conforme con la compra.',
    likes: 14,
    isLiked: false
  }, {
    id: 10,
    user: 'Gladys R.',
    avatar: 'GR',
    emoji: '🐰',
    colorIdx: 1,
    date: 'hace 4 días',
    rating: 5,
    text: 'Ya hice tres mantas para regalar. Los puntos fantasía son hermosos.',
    likes: 19,
    isLiked: false
  }, {
    id: 11,
    user: 'Juana P.',
    avatar: 'JP',
    emoji: '🧸',
    colorIdx: 2,
    date: 'hace 4 días',
    rating: 4,
    text: 'Muy buenos los videos explicativos que vienen de regalo. Ayudan mucho.',
    likes: 8,
    isLiked: false
  }, {
    id: 12,
    user: 'Beatriz L.',
    avatar: 'BL',
    emoji: '✨',
    colorIdx: 3,
    date: 'hace 5 días',
    rating: 5,
    text: 'Es la mejor inversión que hice este año para mi hobby. ¡Sigan así!',
    likes: 25,
    isLiked: false
  }, {
    id: 13,
    user: 'Silvia N.',
    avatar: 'SN',
    emoji: '💜',
    colorIdx: 4,
    date: 'hace 5 días',
    rating: 5,
    text: 'Los patrones de ropa son tendencia total. Me hice un cárdigan que todos me elogian.',
    likes: 16,
    isLiked: false
  }, {
    id: 14,
    user: 'Margarita F.',
    avatar: 'MF',
    emoji: '🌺',
    colorIdx: 5,
    date: 'hace 6 días',
    rating: 5,
    text: 'Todo perfecto, desde el pago hasta la descarga. Muy profesionales.',
    likes: 13,
    isLiked: false
  }, {
    id: 15,
    user: 'Cristina D.',
    avatar: 'CD',
    emoji: '🍀',
    colorIdx: 6,
    date: 'hace 6 días',
    rating: 5,
    text: 'Me encanta que los patrones vengan con gráficos claros. Facilita mucho el trabajo.',
    likes: 17,
    isLiked: false
  }, {
    id: 16,
    user: 'Zulma T.',
    avatar: 'ZT',
    emoji: '🎨',
    colorIdx: 7,
    date: 'hace 1 semana',
    rating: 4,
    text: 'Muy lindo todo. El set de cocina es lo más vendido en mi emprendimiento.',
    likes: 10,
    isLiked: false
  }, {
    id: 17,
    user: 'Olga B.',
    avatar: 'OB',
    emoji: '🪻',
    colorIdx: 0,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Gracias por los consejos para principiantes. Me ayudaron a perder el miedo.',
    likes: 22,
    isLiked: false
  }, {
    id: 18,
    user: 'Nélida G.',
    avatar: 'NG',
    emoji: '🐱',
    colorIdx: 1,
    date: 'hace 1 semana',
    rating: 5,
    text: 'Los amigurumis de animales son los más tiernos que vi. ¡Mis nietos están felices!',
    likes: 20,
    isLiked: false
  }, {
    id: 19,
    user: 'Inés S.',
    avatar: 'IS',
    emoji: '🌷',
    colorIdx: 2,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Excelente material. Se nota que hay mucho trabajo detrás de cada patrón.',
    likes: 18,
    isLiked: false
  }, {
    id: 20,
    user: 'Raquel M.',
    avatar: 'RM',
    emoji: '🫧',
    colorIdx: 3,
    date: 'hace 2 semanas',
    rating: 5,
    text: 'Súper completo. No me canso de descubrir nuevos proyectos para hacer.',
    likes: 23,
    isLiked: false
  }]);
  const [newComment, setNewComment] = useState('');
  const [rating, setRating] = useState(5);
  const [showThanks, setShowThanks] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (!newComment.trim()) return;
    const randomIdx = Math.floor(Math.random() * AVATAR_EMOJIS.length);
    const comment = {
      id: Date.now(),
      user: 'Usuario',
      avatar: 'U',
      emoji: AVATAR_EMOJIS[randomIdx],
      colorIdx: randomIdx % AVATAR_COLORS.length,
      date: 'ahora mismo',
      rating,
      text: newComment,
      likes: 0,
      isLiked: false
    };
    setComments([comment, ...comments]);
    setNewComment('');
    setRating(5);
    setShowThanks(true);
  };
  const toggleLike = (id: number) => {
    setComments(comments.map(c => {
      if (c.id === id) {
        return {
          ...c,
          isLiked: !c.isLiked,
          likes: c.isLiked ? c.likes - 1 : c.likes + 1
        };
      }
      return c;
    }));
  };
  return <ScrollReveal data-id="element-44">
      <div className="max-w-4xl mx-auto p-8 bg-white/40 backdrop-blur-sm rounded-[3rem] border border-[#2F5233]/10 shadow-sm pt-[32px] pb-[32px] mt-[40px] space-y-[24px]" data-id="element-45">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-10 gap-4" data-id="element-46">
          <h3 className="text-3xl font-bold flex items-center gap-3 text-[#2F5233] font-serif" data-id="element-47">
            <MessageCircle className="text-[#E07A5F] w-8 h-8" data-id="element-48" /> Comunidad y
            Feedback
          </h3>
          <div className="flex items-center gap-2 bg-[#2F5233]/5 px-4 py-2 rounded-full border border-[#2F5233]/10" data-id="element-49">
            <div className="flex gap-0.5" data-id="element-50">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-[#E07A5F] text-[#E07A5F]" data-id="element-51" />)}
            </div>
            <span className="text-sm font-bold text-[#2F5233]" data-id="element-52">
              4.9/5 Promedio
            </span>
          </div>
        </div>

        <div className="mb-12 space-y-6 bg-white/60 p-8 rounded-[2.5rem] border border-[#2F5233]/5 shadow-inner" data-id="element-53">
          <div className="flex flex-col gap-4" data-id="element-54">
            <p className="text-sm font-bold text-[#8D7B6D] uppercase tracking-wider" data-id="element-55">
              Tu Calificación:
            </p>
            <div className="flex gap-2" data-id="element-56">
              {[1, 2, 3, 4, 5].map(s => <motion.button key={s} whileHover={{
              scale: 1.2
            }} whileTap={{
              scale: 0.9
            }} onClick={() => setRating(s)} data-id="element-57">
                  <Star className={`w-8 h-8 transition-colors ${s <= rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-58" />
                </motion.button>)}
            </div>
          </div>

          <textarea value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Compartí tu experiencia con la comunidad..." className="w-full bg-white border border-[#2F5233]/10 rounded-2xl p-5 text-[#4A3F35] focus:ring-2 focus:ring-[#2F5233]/20 outline-none transition-all shadow-sm min-h-[120px]" data-id="element-59" />

          <div className="flex flex-wrap items-center justify-end gap-4" data-id="element-60">
            <button onClick={handlePublish} disabled={!newComment.trim()} className="bg-[#2F5233] text-white font-black py-4 px-10 rounded-2xl hover:bg-[#1F3A22] transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed active:scale-95" data-id="element-61">
              Publicar Comentario
            </button>
          </div>
        </div>

        <div className="space-y-4" data-id="element-62">
          <AnimatePresence mode="popLayout" data-id="element-63">
            {comments.slice(0, visibleCount).map(c => <motion.div key={c.id} layout initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} className="bg-white/40 p-4 rounded-2xl border border-[#2F5233]/5 hover:border-[#2F5233]/10 transition-all group" data-id="element-64">
                <div className="flex gap-4" data-id="element-65">
                  <div className={`w-12 h-12 shrink-0 rounded-full flex items-center justify-center shadow-sm border border-white/50 bg-gradient-to-br ${AVATAR_COLORS[c.colorIdx % AVATAR_COLORS.length]}`} data-id="element-66">
                    <span className="text-xl" data-id="element-67">{c.emoji}</span>
                  </div>
                  <div className="flex-1 flex flex-col" data-id="element-68">
                    <div className="flex items-center justify-between mb-2" data-id="element-69">
                      <div className="flex items-center gap-2" data-id="element-70">
                        <div data-id="element-71">
                          <p className="font-bold text-[#2F5233] leading-none text-sm mb-1" data-id="element-72">
                            {c.user}
                          </p>
                          <div className="flex items-center gap-2" data-id="element-73">
                            <div className="flex gap-0.5" data-id="element-74">
                              {Array.from({
                            length: 5
                          }).map((_, i) => <Star key={i} className={`w-2.5 h-2.5 ${i < c.rating ? 'fill-[#E07A5F] text-[#E07A5F]' : 'text-[#E07A5F]/20'}`} data-id="element-75" />)}
                            </div>
                            <span className="text-[9px] text-[#8D7B6D] font-medium" data-id="element-76">
                              • {c.date}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#2F5233]/5 px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-77">
                        <CheckCircle2 className="w-2.5 h-2.5 text-[#2F5233]" data-id="element-78" />
                        <span className="text-[8px] font-bold text-[#2F5233] uppercase" data-id="element-79">
                          Verificada
                        </span>
                      </div>
                    </div>
                    <p className="text-[#4A3F35] text-sm leading-relaxed mb-3 flex-1 italic" data-id="element-80">
                      "{c.text}"
                    </p>
                    <div className="flex items-center justify-between pt-2 border-t border-[#2F5233]/5" data-id="element-81">
                      <button onClick={() => toggleLike(c.id)} className={`flex items-center gap-1.5 px-3 py-1 rounded-full transition-all font-bold text-[11px] ${c.isLiked ? 'bg-[#E07A5F]/10 text-[#E07A5F]' : 'text-[#8D7B6D] hover:bg-[#2F5233]/5'}`} data-id="element-82">
                        <Heart className={`w-3.5 h-3.5 transition-all ${c.isLiked ? 'fill-[#E07A5F]' : ''}`} data-id="element-83" />
                        {c.likes}
                      </button>
                      <button className="text-[10px] font-bold text-[#2F5233]/40 hover:text-[#2F5233] transition-colors" data-id="element-84">
                        Responder
                      </button>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </div>

        {visibleCount < comments.length && <button onClick={() => setVisibleCount(prev => prev + 3)} className="w-full mt-10 py-5 border-2 border-dashed border-[#2F5233]/10 rounded-[2rem] font-black text-[#2F5233] hover:bg-[#2F5233]/5 hover:border-[#2F5233]/20 transition-all uppercase tracking-widest text-sm" data-id="element-85">
            Ver más testimonios de la comunidad
          </button>}

        {showThanks && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/20 backdrop-blur-md p-4" data-id="element-86">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="bg-white text-[#4A3F35] p-10 rounded-[3rem] max-w-sm text-center shadow-2xl border border-[#2F5233]/10" data-id="element-87">
              <div className="bg-[#2F5233]/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-88">
                <CheckCircle2 className="text-[#2F5233] w-12 h-12" data-id="element-89" />
              </div>
              <h4 className="text-2xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-90">
                ¡Gracias por inspirarnos!
              </h4>
              <p className="text-[#8D7B6D] mb-8 leading-relaxed" data-id="element-91">
                Tu proyecto y tu opinión son el motor de esta comunidad.
              </p>
              <button onClick={() => setShowThanks(false)} className="w-full bg-[#2F5233] text-white py-4 rounded-2xl font-black shadow-lg hover:bg-[#1F3A22] transition-colors uppercase tracking-wider" data-id="element-92">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </div>
    </ScrollReveal>;
};
const ProjectCarousel = () => {
  return <div className="w-full overflow-hidden py-12 bg-[#2F5233]/5 rounded-[3rem] border border-[#2F5233]/10" data-id="element-93">
      <div className="text-center mb-10" data-id="element-94">
        <h3 className="text-3xl font-bold text-[#2F5233] font-serif" data-id="element-95">
          Proyectos Terminados por la Comunidad
        </h3>
        <p className="text-[#8D7B6D]" data-id="element-96">
          Inspirate con lo que vos también vas a lograr
        </p>
      </div>

      <div className="flex relative" data-id="element-97">
        <motion.div className="flex gap-6 px-6" animate={{
        x: [0, -2500]
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-98">
          {[...PROJECTS, ...PROJECTS].map((project, idx) => <div key={idx} className="min-w-[300px] bg-white rounded-3xl overflow-hidden shadow-md border border-[#2F5233]/5 group" data-id="element-99">
              <div className="h-64 overflow-hidden" data-id="element-100">
                <img src={project.url} alt={project.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-101" />
              </div>
              <div className="p-6" data-id="element-102">
                <h4 className="font-bold text-[#2F5233] mb-2" data-id="element-103">
                  {project.title}
                </h4>
                <p className="text-sm text-[#8D7B6D] italic" data-id="element-104">
                  "{project.comment}"
                </p>
              </div>
            </div>)}
        </motion.div>
      </div>
    </div>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-[#2F5233]/10 last:border-0" data-id="element-105">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left gap-4 group" data-id="element-106">
        <div className="flex items-center gap-4" data-id="element-107">
          <div className="w-10 h-10 rounded-full bg-[#2F5233]/5 flex items-center justify-center shrink-0 group-hover:bg-[#2F5233]/10 transition-colors" data-id="element-108">
            <HelpCircle className="w-5 h-5 text-[#E07A5F]" data-id="element-109" />
          </div>
          <span className="text-lg font-bold text-[#2F5233] font-serif" data-id="element-110">
            {question}
          </span>
        </div>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-111">
          <ChevronDown className="w-6 h-6 text-[#8D7B6D] mb-[80px]" data-id="element-112" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-113">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-114">
            <p className="pb-6 pl-14 text-[#8D7B6D] leading-relaxed" data-id="element-115">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const FAQSection = () => {
  const faqs = [{
    question: '¿Cómo recibo mi biblioteca de patrones?',
    answer: 'La entrega es inmediata y digital. Una vez confirmado tu pago, recibirás un correo electrónico con el acceso para descargar toda la biblioteca completa en formato PDF. Podrás verlos en tu celular, tablet o computadora.'
  }, {
    question: '¿Por cuánto tiempo tendré acceso a los patrones?',
    answer: '¡El acceso es de por vida! Una vez que realizás la compra, los patrones son tuyos para siempre. Podés descargarlos las veces que necesites y guardarlos en tus dispositivos para consultarlos en cualquier momento, incluso sin internet.'
  }, {
    question: '¿Los patrones están en español?',
    answer: 'Sí, todos los patrones y guías de la biblioteca están completamente en español, con términos claros y fáciles de seguir para que no tengas ninguna duda al tejer.'
  }, {
    question: '¿Puedo imprimir los archivos PDF?',
    answer: '¡Absolutamente! Los archivos están optimizados en alta resolución para que puedas imprimirlos en casa o en una gráfica y tener tus patrones físicamente en tu rincón de tejido.'
  }, {
    question: '¿Necesito ser experta para usar estos patrones?',
    answer: 'Para nada. La biblioteca incluye desde proyectos muy simples para quienes recién comienzan hasta diseños complejos para tejedoras avanzadas. Cada patrón incluye gráficos y explicaciones detalladas paso a paso.'
  }];
  return <ScrollReveal data-id="element-116">
      <section className="max-w-3xl mx-auto px-6 mt-[0px] mb-[0px]" data-id="element-117">
        <div className="text-center mb-12" data-id="element-118">
          <h2 className="text-4xl font-bold text-[#2F5233] font-serif mb-4" data-id="element-119">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#8D7B6D]" data-id="element-120">
            Todo lo que necesitás saber sobre Hilos que Enamoran
          </p>
        </div>
        <div className="bg-white/60 backdrop-blur-sm rounded-[2.5rem] p-8 border border-[#2F5233]/10 shadow-sm" data-id="element-121">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-122" />)}
        </div>
      </section>
    </ScrollReveal>;
};
const App = () => {
  useEffect(() => {
    const pixelId = '1293858232676625';
    // Inject Meta Pixel script directly
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      if(s&&s.parentNode){s.parentNode.insertBefore(t,s)}
      else{b.head.appendChild(t)}}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [spots, setSpots] = useState(13);
  const [viewers, setViewers] = useState(48);
  const [titleVisible, setTitleVisible] = useState(true);
  useEffect(() => {
    const titleInterval = setInterval(() => {
      setTitleVisible(false);
      setTimeout(() => setTitleVisible(true), 4000);
    }, 14000);
    return () => clearInterval(titleInterval);
  }, []);
  const today = new Date().toLocaleDateString('es-AR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  useEffect(() => {
    const spotInt = setInterval(() => {
      setSpots(prev => prev > 2 ? prev - 1 : prev);
    }, 45000);
    const viewerInt = setInterval(() => {
      setViewers(prev => Math.floor(Math.random() * (55 - 35 + 1)) + 35);
    }, 10000);
    return () => {
      clearInterval(spotInt);
      clearInterval(viewerInt);
    };
  }, []);
  const scrollToPurchase = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handlePurchase = () => {
    window.location.href = CHECKOUT_LINK;
  };
  return <div className="min-h-screen selection:bg-[#2F5233]/20 selection:text-[#2F5233]" data-id="element-123">
      <StickyHeader onAction={scrollToPurchase} data-id="element-124" />
      <PurchasePopup data-id="element-125" />

      {/* Header Banner */}
      <div className="text-white py-1.5 text-center font-bold px-4 shadow-sm relative z-50 bg-gradient-to-r from-[#9FD9D3] via-[#82c9c1] to-[#9FD9D3] flex items-center justify-center gap-4" data-id="element-126">
        <div className="flex items-center gap-2" data-id="element-127">
          <Calendar className="w-3.5 h-3.5 text-[#2F5233]" data-id="element-128" />
          <span className="text-[#2F5233] uppercase tracking-wider text-[10px]" data-id="element-129">
            OFERTA VÁLIDA SOLO HOY: {today}
          </span>
        </div>
        <div className="h-3 w-px bg-[#2F5233]/20 hidden sm:block" data-id="element-130" />
        <CountdownTimer data-id="element-131" />
      </div>

      {/* Full Screen Hero Section */}
      <section className="relative h-[90vh] w-full overflow-hidden flex flex-col items-center justify-start" data-id="element-132">
        {/* New Elegant H1 Title - Positioned at Top 10% */}
        <AnimatePresence data-id="element-133">
          {titleVisible && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} className="absolute top-[10%] z-30 flex flex-col items-center justify-center px-6 text-center w-full" data-id="element-134">
              <h1 className="md:text-5xl italic drop-shadow-sm bg-transparent text-[#3D2B1F] font-[800] text-[28px] font-[Manrope,_sans-serif] mt-[-32px] mb-[-32px]" data-id="element-135">
                Crea Piezas Con Alma.
              </h1>
            </motion.div>}
        </AnimatePresence>

        {/* Cinemagraph Background */}
        <motion.div initial={{
        scale: 1.05
      }} animate={{
        scale: 1
      }} transition={{
        duration: 15,
        ease: 'easeOut'
      }} className="absolute inset-0 z-[1]" data-id="element-136">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transform-gpu" style={{
          backgroundImage: `url(${HERO_BG})`
        }} data-id="element-137" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#FEFDF5]/40 via-transparent to-[#FEFDF5]" data-id="element-138" />
        </motion.div>

        {/* Dust Particles */}
        <div className="absolute inset-0 z-10 pointer-events-none" data-id="element-139">
          {Array.from({
          length: 30
        }).map((_, i) => <motion.div key={i} className="absolute w-2 h-2 bg-[#E07A5F]/20 rounded-full blur-[1px]" style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`
        }} animate={{
          y: [0, -100, 0],
          opacity: [0.1, 0.4, 0.1]
        }} transition={{
          duration: 8 + Math.random() * 10,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-140" />)}
        </div>
      </section>

      {/* Direct Access Section - Delicate CTA */}
      <ScrollReveal data-id="element-141">
        <div className="flex justify-center -mt-12 relative z-20 px-6" data-id="element-142">
          <button onClick={scrollToPurchase} className="group bg-white/80 backdrop-blur-md border border-[#2F5233]/20 px-8 py-4 rounded-full shadow-[0_10px_30px_rgba(47,82,51,0.1)] flex items-center hover:bg-[#2F5233] hover:text-white transition-all duration-500 active:scale-95 pt-[8px] pb-[8px] gap-[8px]" data-id="element-143">
            <div className="w-10 h-10 bg-[#E07A5F] rounded-full flex items-center justify-center text-white shadow-sm group-hover:bg-white group-hover:text-[#E07A5F] transition-colors" data-id="element-144">
              <Ticket className="w-5 h-5" data-id="element-145" />
            </div>
            <div className="text-left" data-id="element-146">
              <p className="font-bold uppercase tracking-[0.2em] opacity-60 mb-1 text-[12px]" data-id="element-147">
                Acceso Inmediato
              </p>
              <p className="font-black uppercase tracking-tight text-[12px]" data-id="element-148">
                Obtener Mi Biblioteca Ahora
              </p>
            </div>
            <ChevronRight className="w-5 h-5 opacity-30 group-hover:opacity-100 group-hover:translate-x-1 transition-all" data-id="element-149" />
          </button>
        </div>
      </ScrollReveal>

      <main className="max-w-5xl mx-auto px-6 py-12 pt-[48px] pb-[48px] pl-[10px] pr-[10px] space-y-[22px]" data-id="element-150">
        {/* Subtitle - Moved below Hero */}
        <ScrollReveal data-id="element-151">
          <section className="text-center" data-id="element-152"></section>
        </ScrollReveal>

        {/* Sales Letter */}
        <section className="prose prose-lg max-w-none space-y-12 text-[#4A3F35] leading-relaxed" data-id="element-153">
          <ScrollReveal data-id="element-154">
            <p className="font-bold text-[#2F5233] text-3xl font-serif" data-id="element-155">
              Querida amante del crochet,
            </p>
          </ScrollReveal>

          <ScrollReveal delay={0.2} data-id="element-156">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-157">
              <div className="space-y-6" data-id="element-158">
                <p data-id="element-159">Entiendo perfectamente esa sensación.</p>
                <p data-id="element-160">
                  Estás sentada en tu lugar favorito, con el ovillo de lana
                  perfecto y la ilusión de empezar un nuevo proyecto. Pasaste
                  horas buscando en internet un diseño que te emocionara y
                  finalmente encontrás un patrón "gratis".
                </p>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/k7MD9rNXk2rd4ka6qtvPBP/quiero_que_una_202604231645.webp" className="rounded-[2.5rem] shadow-xl w-full h-80 object-cover" alt="Textura de lana" data-id="element-161" />
            </div>
          </ScrollReveal>

          <ScrollReveal data-id="element-162">
            <p className="text-[#E07A5F] font-bold text-4xl font-serif text-center" data-id="element-163">
              Y de repente... el desastre.
            </p>
          </ScrollReveal>

          <ScrollReveal data-id="element-164">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-165">
              <img src="https://cdn.magicpatterns.com/uploads/tBAoGeMvpwhtqzwwJDSXYX/quiero_que_me_202604231650.webp" className="rounded-[2.5rem] shadow-xl w-full h-80 object-cover order-2 md:order-1" alt="Frustración con el tejido" data-id="element-166" />
              <div className="space-y-6 order-1 md:order-2" data-id="element-167">
                <p data-id="element-168">
                  Llegás a la mitad del camino y los puntos no coinciden. El
                  patrón dice una cosa, pero lo que tenés en las manos es un
                  desorden sin forma. Intentás arreglarlo, pero queda deforme.
                </p>
                <p data-id="element-169">
                  Con dolor en el alma, tenés que desarmar. Tirás del hilo y
                  sentís que con cada punto que deshaces, se te va un pedacito
                  de tu tiempo y de tu ilusión.
                </p>
              </div>
            </div>
          </ScrollReveal>

          <ScrollReveal data-id="element-170">
            <div className="my-16 text-center" data-id="element-171">
              <button onClick={scrollToPurchase} className="w-full max-w-2xl bg-[#E07A5F] text-white text-xl md:text-2xl font-black py-8 rounded-[2rem] shadow-xl hover:bg-[#D1694E] active:scale-[0.98] transition-all flex items-center justify-center gap-3 uppercase animate-slow-pulse" data-id="element-172">
                SÍ, QUIERO MI BIBLIOTECA DE MAESTRÍA AHORA{' '}
                <ChevronRight className="w-8 h-8" data-id="element-173" />
              </button>
            </div>
          </ScrollReveal>

          <ScrollReveal data-id="element-174">
            <div className="bg-white/40 backdrop-blur-sm p-12 rounded-[3rem] border border-[#2F5233]/10 shadow-sm pt-[30px] pb-[30px] space-y-[32px]" data-id="element-175">
              <h3 className="text-4xl font-bold text-[#2F5233] mb-8" data-id="element-176">
                ¿Qué vas a lograr con Hilos que Enamoran?
              </h3>
              <div className="grid md:grid-cols-2 gap-8" data-id="element-177">
                {[{
                title: 'Certidumbre Total',
                desc: 'Cada uno de los 3,000 patrones ha sido seleccionado bajo nuestro Sistema de Patrones de Alta Fidelidad.',
                emoji: '🎯'
              }, {
                title: 'Variedad Sin Límites',
                desc: 'Desde amigurumis que parecen tener alma, hasta prendas de moda de lujo.',
                emoji: '🌈'
              }, {
                title: 'Ahorro Real',
                desc: 'Dejá de tirar plata en lana que termina enredada y desarmada.',
                emoji: '💰'
              }, {
                title: 'Reconocimiento',
                desc: 'Preparate para que tu familia y amigas vean tu tejido como el arte profesional que es.',
                emoji: '✨'
              }].map((item, idx) => <motion.div key={idx} whileHover={{
                scale: 1.05,
                backgroundColor: 'rgba(255, 255, 255, 0.6)'
              }} transition={{
                type: 'spring',
                stiffness: 300,
                damping: 20
              }} className="flex gap-4 items-start bg-white/40 p-8 rounded-[2.5rem] border border-[#2F5233]/10 shadow-sm cursor-default" data-id="element-178">
                    <div className="text-3xl shrink-0 mt-1 bg-[#2F5233]/5 w-14 h-14 rounded-2xl flex items-center justify-center shadow-inner" data-id="element-179">
                      {item.emoji}
                    </div>
                    <span data-id="element-180">
                      <strong className="text-[#2F5233] block text-xl mb-2 font-serif" data-id="element-181">
                        {item.title}
                      </strong>
                      <p className="text-[#4A3F35] leading-relaxed" data-id="element-182">
                        {item.desc}
                      </p>
                    </span>
                  </motion.div>)}
              </div>
            </div>
          </ScrollReveal>
        </section>

        {/* Project Carousel */}
        <ScrollReveal data-id="element-183">
          <ProjectCarousel data-id="element-184" />
        </ScrollReveal>

        {/* Bonuses Section */}
        <section className="mt-32" data-id="element-185">
          <ScrollReveal data-id="element-186">
            <div className="text-center mb-16" data-id="element-187">
              <h3 className="text-4xl md:text-6xl font-black mb-6 text-[#2F5233] pt-[22px] pb-[22px]" data-id="element-188">
                Y SI TE UNÍS AHORA, RECIBÍS ESTOS{' '}
                <span className="text-[#E07A5F]" data-id="element-189">5 BONOS EXCLUSIVOS</span>:
              </h3>
              <p className="text-[#E07A5F] font-bold text-2xl animate-pulse" data-id="element-190">
                ¡GRATIS SOLO POR EL DÍA DE HOY!
              </p>
            </div>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-191">
            {BONUSES.map((bonus, idx) => <ScrollReveal key={bonus.id} delay={idx * 0.1} data-id="element-192">
                <div className="bg-white/60 rounded-[3rem] overflow-hidden border border-[#2F5233]/10 hover:border-[#2F5233]/30 transition-all group cursor-pointer shadow-sm hover:shadow-xl" onClick={handlePurchase} data-id="element-193">
                  <div className="aspect-[4/3] overflow-hidden p-4" data-id="element-194">
                    <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover rounded-[2rem] border-4 border-white shadow-md group-hover:scale-105 transition-transform duration-1000 pl-[15px] pr-[15px]" data-id="element-195" />
                  </div>
                  <div className="p-8 pt-2" data-id="element-196">
                    <h4 className="text-xl font-bold mb-3 text-[#2F5233] font-serif" data-id="element-197">
                      {bonus.title}
                    </h4>
                    <p className="text-[#8D7B6D] text-base leading-relaxed mb-6" data-id="element-198">
                      {bonus.desc}
                    </p>
                    <div className="flex items-center justify-between pt-6 border-t border-[#2F5233]/5" data-id="element-199">
                      <span className="text-sm font-bold text-[#8D7B6D] line-through" data-id="element-200">
                        VALOR: $10.000 pesos
                      </span>
                      <span className="text-xl font-bold text-[#E07A5F]" data-id="element-201">
                        GRATIS
                      </span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </section>

        {/* Summary Section: What you get */}
        <ScrollReveal data-id="element-202">
          <section className="mt-32 mb-20" data-id="element-203">
            <div className="bg-white/40 backdrop-blur-md rounded-[4rem] p-8 md:p-16 border border-[#2F5233]/10 shadow-sm text-center" data-id="element-204">
              <h3 className="text-4xl md:text-5xl font-bold text-[#2F5233] font-serif mb-8" data-id="element-205">
                Tu Colección Completa de Maestría
              </h3>
              <p className="text-xl text-[#8D7B6D] mb-12 max-w-2xl mx-auto" data-id="element-206">
                Esto es todo lo que vas a recibir hoy al unirte a nuestra
                comunidad. Una biblioteca diseñada para transformar tu pasión en
                arte.
              </p>
              <div className="relative group" data-id="element-207">
                <div className="absolute -inset-4 bg-gradient-to-r from-[#E07A5F]/10 via-[#2F5233]/5 to-[#E07A5F]/10 rounded-[3rem] blur-2xl opacity-50 group-hover:opacity-100 transition-opacity duration-1000" data-id="element-208" />
                <img src="https://cdn.magicpatterns.com/uploads/dEePxkD6PShBpYggRNjsQe/ChatGPT_Image_27_abr_2026,_13_26_57.webp" alt="Colección Completa Hilos que Enamoran" className="relative w-full max-w-4xl mx-auto rounded-[2.5rem] shadow-2xl border-8 border-white" data-id="element-209" />
              </div>
              <div className="mt-12 flex flex-wrap justify-center gap-6" data-id="element-210">
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-211">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-212" />
                  <span data-id="element-213">Ebook Principal</span>
                </div>
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-214">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-215" />
                  <span data-id="element-216">5 Bonos Exclusivos</span>
                </div>
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-217">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-218" />
                  <span data-id="element-219">Acceso de por Vida</span>
                </div>
                <div className="flex items-center gap-2 text-[#2F5233] font-bold" data-id="element-220">
                  <CheckCircle2 className="w-5 h-5 text-[#E07A5F]" data-id="element-221" />
                  <span data-id="element-222">Formato PDF Digital</span>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Pricing Section */}
        <ScrollReveal data-id="element-223">
          <section id="pricing" className="text-center py-24 bg-white/60 backdrop-blur-sm rounded-[4rem] border border-[#2F5233]/10 shadow-2xl overflow-hidden relative pt-[0px] pb-[0px] pl-[2px] pr-[2px] mt-[40px] mb-[40px] space-y-[4px]" data-id="element-224">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#E07A5F]/5 rounded-full -mr-32 -mt-32 blur-3xl" data-id="element-225" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#2F5233]/5 rounded-full -ml-32 -mb-32 blur-3xl" data-id="element-226" />

            <h3 className="md:text-5xl font-bold text-[#2F5233] font-serif text-[20px] pl-[20px] pr-[20px] mt-[1px] mb-[1px] pt-[30px] pb-[30px]" data-id="element-227">
              INVERTÍ EN TU TALENTO HOY
            </h3>
            <div className="mt-[20px] mb-[20px] pb-[22px]" data-id="element-228">
              <p className="text-[#8D7B6D] line-through text-3xl mb-4" data-id="element-229">
                Antes $50.000 pesos
              </p>
              <p className="md:text-[10rem] font-black mb-8 tracking-tighter text-[48px] text-[#1DB343]" data-id="element-230">
                $19.990 ARS
              </p>

              <div className="inline-flex bg-[#2F5233]/5 text-[#2F5233] px-10 py-5 rounded-full font-bold border border-[#2F5233]/10 pl-[10px] pr-[10px] pt-[0px] pb-[0px] ml-[20px] mr-[20px] gap-[0px] items-center justify-start" data-id="element-231">
                <CreditCard className="w-7 h-7 text-[#E07A5F] bg-[#FFFFFF]" data-id="element-232" />
                <span className="text-xl text-[#007517]" data-id="element-233">
                  Hasta 3 cuotas sin interés
                </span>
              </div>
            </div>

            <button onClick={handlePurchase} className="w-full max-w-2xl mx-auto text-white font-black py-10 rounded-[2.5rem] shadow-2xl hover:bg-[#1F3A22] active:scale-[0.98] transition-all flex uppercase mb-6 animate-slow-pulse flex-col items-center justify-center text-[28px] bg-[#32B742] gap-[16px] pt-[10px] pb-[10px]" data-id="element-234">
              ¡SÍ, QUIERO EL PAQUETE COMPLETO!
            </button>

            {/* Redesigned Payment Logos Section */}
            <div className="max-w-2xl mx-auto mb-10 space-y-6" data-id="element-235">
              <p className="text-[10px] font-bold text-[#8D7B6D] uppercase tracking-widest" data-id="element-236">
                MEDIOS DE PAGO PROCESADOS
              </p>

              <div className="flex flex-wrap justify-center items-center gap-4 opacity-80" data-id="element-237">
                <img src="https://cdn.magicpatterns.com/uploads/fNV98cCBQcKZk5qb2Hkk7G/VISA.png" alt="VISA" className="h-6 w-auto object-contain" data-id="element-238" />
                <img src="https://cdn.magicpatterns.com/uploads/pyX1ZaboBbkYDwwZiV7vr7/mastercard.webp" alt="Mastercard" className="h-6 w-auto object-contain" data-id="element-239" />
                <div className="h-6 w-10 bg-[#016FD0] rounded flex items-center justify-center font-bold text-white text-[6px]" data-id="element-240">
                  AMEX
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/iNMH1DKK24VXHynBrVGPZq/naranja.png" alt="Naranja" className="h-6 w-auto object-contain" data-id="element-241" />
                <div className="h-6 w-10 bg-[#008248] rounded flex items-center justify-center font-bold text-white text-[6px]" data-id="element-242">
                  CABAL
                </div>
              </div>

              <div className="flex justify-center items-center" data-id="element-243">
                <img src="https://cdn.magicpatterns.com/uploads/5UQzX3Bg1aaK5XZJ8qMgYp/medios-de-pago.png" alt="Medios de Pago" className="h-24 md:h-32 w-auto object-contain" data-id="element-244" />
              </div>

              {/* Mercado Pago Button */}
              <button onClick={handlePurchase} className="w-full bg-[#009EE3] text-white p-4 rounded-2xl shadow-lg hover:bg-[#0087C1] transition-all flex items-center gap-4 text-left group pb-[16px]" data-id="element-245">
                <div className="bg-white p-2 rounded-full shadow-inner group-hover:scale-110 transition-transform" data-id="element-246">
                  <Handshake className="w-6 h-6 text-[#009EE3]" data-id="element-247" />
                </div>
                <div data-id="element-248">
                  <p className="font-black text-lg leading-none uppercase" data-id="element-249">
                    PAGÁ CON MERCADO PAGO
                  </p>
                  <p className="text-xs opacity-90" data-id="element-250">
                    Cuotas sin Interés y seguridad garantizada
                  </p>
                </div>
              </button>
            </div>

            {/* Redesigned Trust Banner */}
            <div className="bg-[#041122] text-white py-12 px-6 overflow-hidden rounded-[3rem] border-4 border-[#D4AF37]/20 pt-[48px]" data-id="element-251">
              <div className="max-w-6xl mx-auto" data-id="element-252">
                <div className="grid lg:grid-cols-[auto_1fr_auto] gap-10 items-center" data-id="element-253">
                  {/* Left: Guarantee Seal */}
                  <div className="relative shrink-0 mx-auto" data-id="element-254">
                    <img src="https://cdn.magicpatterns.com/uploads/wHZDSnets98iTAM62U8Kre/garantia-sello.png" alt="Garantía 7 Días" className="w-40 h-40 object-contain drop-shadow-2xl" data-id="element-255" />
                  </div>

                  {/* Center: Compra Segura */}
                  <div className="text-left pl-[20px] pr-[20px] space-y-[8px]" data-id="element-256">
                    <div className="flex items-center gap-2 text-[#28CD3E]" data-id="element-257">
                      <CheckCircle2 className="w-6 h-6" data-id="element-258" />
                      <h4 className="text-2xl font-black uppercase tracking-tight" data-id="element-259">
                        COMPRA SEGURA
                      </h4>
                    </div>
                    <h5 className="text-xl font-bold uppercase tracking-wide" data-id="element-260">
                      GARANTÍA INCONDICIONAL
                    </h5>
                    <p className="text-sm text-white/70 leading-relaxed max-w-md" data-id="element-261">
                      Garantía de satisfacción total. Si el contenido no cumple
                      tus expectativas, te devolvemos el dinero sin preguntas.
                    </p>
                  </div>

                  {/* Right: Mercado Libre Verified */}
                  <div className="flex flex-col items-center gap-4 bg-white p-4 rounded-[2rem] border border-white/10 shadow-xl" data-id="element-262">
                    <img src="https://cdn.magicpatterns.com/uploads/7md84kaW1kCVoHpQDKEEji/es-seguro-comprar-en-mercado-libre-v0-f57o8o5uoudc1.webp" alt="Vendedor Verificado" className="w-full max-w-[320px] h-auto rounded-xl" data-id="element-263" />
                  </div>
                </div>

                {/* Bottom Line */}
                <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 pl-[20px] pr-[20px]" data-id="element-264">
                  <div className="flex items-center gap-3" data-id="element-265">
                    <Calendar className="w-6 h-6 text-[#FFD200]" data-id="element-266" />
                    <span className="font-black uppercase tracking-tight text-[12px]" data-id="element-267">
                      GARANTÍA TOTAL DE 7 DÍAS{' '}
                      <span className="font-normal opacity-70" data-id="element-268">
                        (reembolso garantizado)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-269">
                    <InfinityIcon className="w-6 h-6 text-[#FFD200]" data-id="element-270" />
                    <span className="text-sm font-black uppercase tracking-tight" data-id="element-271">
                      ACCESO DE POR VIDA{' '}
                      <span className="font-normal opacity-70" data-id="element-272">
                        al contenido completo
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Final CTA */}
        <ScrollReveal data-id="element-273">
          <section className="mt-40 text-center pb-20" data-id="element-274">
            <h3 className="text-5xl md:text-7xl font-black mb-12 text-[#2F5233] font-serif leading-tight" data-id="element-275">
              ¿Vas a seguir perdiendo el tiempo o vas a empezar a crear arte?
            </h3>
            <p className="text-2xl md:text-3xl text-[#8D7B6D] mb-20 max-w-4xl mx-auto leading-relaxed" data-id="element-276">
              No dejes que tu talento se oxide en la frustración de los patrones
              gratuitos de mala calidad. Recuperá tu orgullo, dominá la técnica
              y sorprendé al mundo con lo que sos capaz de hacer.
            </p>
            <button onClick={scrollToPurchase} className="bg-[#E07A5F] text-white font-black px-20 py-12 rounded-[3rem] shadow-2xl hover:bg-[#D1694E] active:scale-[0.98] transition-all flex items-center justify-center uppercase mx-auto animate-slow-pulse text-[14px] gap-[24px] pt-[10px] pb-[10px]" data-id="element-277">
              SÍ, QUIERO MI BIBLIOTECA DE MAESTRÍA AHORA
            </button>
          </section>
        </ScrollReveal>

        <FAQSection data-id="element-278" />

        <CommentSection data-id="element-279" />
      </main>

      <footer className="bg-white/20 py-24 border-t border-[#2F5233]/10 text-center text-[#8D7B6D] text-lg" data-id="element-280">
        <ScrollReveal data-id="element-281">
          <p className="mb-4" data-id="element-282">
            © {new Date().getFullYear()} Hilos que Enamoran. Todos los derechos
            reservados.
          </p>
          <p className="max-w-2xl mx-auto opacity-60" data-id="element-283">
            Este sitio no es parte de Facebook ni de Google Inc.
          </p>
        </ScrollReveal>
      </footer>
    </div>;
};
export { App };